module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargador-dd-ap-b446a0f2.png";